<template>
  <div class="col s12 measurement-page">
     <!-- Show answer modal -->
    <div id="showAnswerModal" class="modal">
      <div class="modal-content">
        <h4>Answer</h4>
        <p><pre>{{ modalAnswer }}</pre></p>
      </div>
      <div class="modal-footer">
        <a href="#!" class="modal-close waves-effect waves-green btn-flat">close</a>
      </div>
    </div>

    <div class="row">
      <div class="col s12">
        <div class="section no-padding">
          <h5>Axlecounter</h5>
          <p>Measurement</p>
        </div>
        <div class="divider"></div>
      </div>
    </div>
    <div class="row">
      <div class="col s2">
        <div class="section no-padding">
          <h5>Filters</h5>
        </div>
      <div class="divider"></div>

      <p>Commandtype</p>
      <p v-for="(item, index) in distinctCommandTypes" v-bind:key="index">
        <label>
          <input type="checkbox" @change="filterCommandType(item)" checked />
          <span>{{ commandToText(item) }}</span>
        </label>
      </p>

      <!--
      <p>Visible rows {{ paging.itemsPerPage }}</p>
      <p class="range-field">
        <input type="range" step="1" min="1" max="100" v-model="paging.itemsPerPage" />
      </p>
      -->

      </div>
      <div class="col s10">
        <p v-show="filteredMeasurementItems.length === 0">No measurements available</p>
        <table class="striped" v-show="filteredMeasurementItems.length !== 0">
          <thead>
            <tr>
              <th>Datetime</th>
              <th>State</th>
              <th>Command</th>
              <th>Answer</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="(item, index) in filteredMeasurementItems" v-bind:key="index"
              v-show="index + 1 <= (paging.itemsPerPage * paging.selectedPage) &&
              index + 1 > ((paging.itemsPerPage * paging.selectedPage) -paging.itemsPerPage)">
              <td>{{ formatDateTime(niceDateTime(item.MeasurementDateTime)) }}</td>
              <td>{{ $t(statusToText(item.Status)) }}</td>
              <td>{{ commandToText(item.Command) }}</td>
              <td @click="modalAnswer = item.Answer" class="left-align clickable modal-trigger" href="#showAnswerModal"><i style="margin-right: 12px" class="material-icons">visibility</i>{{ truncateAnswer(item.Answer) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row">
      <div class="col s12">
        <ul class="pagination center-align" v-if="paging.enabled && filteredMeasurementItems.length > 0">
          <li
            :class="{ disabled: paging.selectedPage === 1, 'waves-effect': paging.selectedPage > 1 }"
            @click="paging.selectedPage !== 1 && paging.selectedPage--">
            <i class="material-icons">chevron_left</i>
          </li>

          <li
            v-for="(pageNumber, index) in paging.numberOfPages" v-bind:key="index"
            class="waves-effect"
            :class="{ active: paging.selectedPage == pageNumber }"
            @click="paging.selectedPage = pageNumber"
          >
            <a>{{ pageNumber }}</a>
          </li>

          <li :class="{ disabled: paging.selectedPage === paging.numberOfPages, 'waves-effect': paging.selectedPage < paging.numberOfPages }"
            @click="paging.selectedPage !== paging.numberOfPages && paging.selectedPage++">
            <i class="material-icons">chevron_right</i>
          </li>
        </ul>
      </div>
    </div>
    <div class="row">
      <div class="col s12">
        <div class="divider" style="margin-bottom: 12px"></div>
      </div>
    </div>
  </div>
</template>

<script>
import AxleCounterService from '@/services/AxleCounterService'
import moment from 'moment'

export default {
  data () {
    return {
      MeasurementItems: [],
      modalAnswer: '',
      truncateAnswerNrOfCharacters: 100,
      paging: {
        enabled: true,
        itemsPerPage: 13,
        numberOfPages: 0,
        selectedPage: 1,
        chevronLeftActive: false,
        chevronRightActive: false
      },
      maxRows: {
        startFrom: 0,
        nrOfRows: 100
      },
      // All command types
      distinctCommandTypes: [],
      // Filtered command types
      activeCommandTypes: []
    }
  },
  computed: {
    filteredMeasurementItems: function () {
      return this.MeasurementItems.filter(mi => this.activeCommandTypes.includes(mi.Command))
    }
  },
  mounted: function () {
    M.Modal.init(document.querySelectorAll('.modal'), { dismissible: true })
    this.getMeasurements()
  },
  watch: {
    '$route.params.railobjectid': {
      handler: function (val, oldVal) {
        this.getMeasurements()
      },
      deep: true,
      immediate: true
    },
    activeCommandTypes: function () {
      this.setPagingParameters()
    },
    'paging.itemsPerPage': function () {
      this.setPagingParameters()
    }
  },
  methods: {
    filterCommandType: function (commandType) {
      if (this.activeCommandTypes.includes(commandType)) {
        this.activeCommandTypes = this.activeCommandTypes.filter(function (item) {
          return item !== commandType
        })
      } else {
        this.activeCommandTypes.push(commandType)
      }
    },
    truncateAnswer: function (answer) {
      return answer.substring(0, this.truncateAnswerNrOfCharacters) + '...'
    },
    getMeasurements: function () {
      this.MeasurementItems = []
      AxleCounterService.GetMeasurementByRailobjectid(this.$route.params.railobjectid, this.maxRows.startFrom, this.maxRows.nrOfRows).then(result => {
        this.MeasurementItems = result.data
      }).then(() => {
        var commandTypes = [...new Set(this.MeasurementItems.map(item => item.Command))]
        this.activeCommandTypes = commandTypes
        this.distinctCommandTypes = commandTypes

        this.setPagingParameters()
      })
    },
    setPagingParameters: function () {
      this.paging.selectedPage = 1
      this.paging.numberOfPages = Math.ceil(this.filteredMeasurementItems.length / this.paging.itemsPerPage)
    },
    statusToText (status) {
      if (status === 1003) return 'axlecounter.statusFailed'
      if (status === 1002) return 'axlecounter.statusWarning'
      if (status === 1001) return 'axlecounter.statusUnknown'
      if (status === 1000) return 'axlecounter.statusOK'
      else return 'axlecounter.statusUnknown'
    },
    commandToText (command) {
      if (command === 's') return '(s) State of section'
      if (command === 't') return '(t) TER'
      if (command === 'a') return '(a) Diag'
      if (command === 'f') return '(f) F-Bits'
      if (command === 'h') return '(h)'
      if (command === 'r') return '(r)'
      else return command
    },
    formatDateTime: (dateTime) => {
      return moment(String(dateTime)).format('DD-MM-YYYY HH:mm')
    },
    niceDateTime (dt) {
      return (
        dt.slice(0, 4) +
        '-' +
        dt.slice(4, 6) +
        '-' +
        dt.slice(6, 8) +
        'T' +
        dt.slice(8, 10) +
        ':' +
        dt.slice(10, 12) +
        ':' +
        dt.slice(12, 14)
      )
    }
  }
}
</script>

<style scoped>
.measurement-page {
  overflow-y: auto;
  height: 84vh;
}
</style>



// WEBPACK FOOTER //
// src/pages/axlecounter/_measurement.vue